import * as Types from '../../../generated/graphql';

import { CircleTopicFragment } from './topic.generated';
import { gql } from 'graphql.macro';
import { CircleTopicFragmentDoc } from './topic.generated';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CircleSeriesFragment = (
  { __typename: 'CircleSeriesNode' }
  & Pick<Types.CircleSeriesNode, 'name' | 'id' | 'slug' | 'uuid' | 'description' | 'shortDescription' | 'illustration'>
);

export type FetchSeriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchSeriesQuery = (
  { __typename: 'Query' }
  & { circleSeriesCollection: (
    { __typename: 'CircleSeriesCollection' }
    & Pick<Types.CircleSeriesCollection, 'totalCount'>
    & { items: Array<Types.Maybe<(
      { __typename: 'CircleSeriesNode' }
      & CircleSeriesFragment
    )>> }
  ) }
);

export type FetchSeriesWithSessionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchSeriesWithSessionsQuery = (
  { __typename: 'Query' }
  & { circleSeriesCollection: (
    { __typename: 'CircleSeriesCollection' }
    & Pick<Types.CircleSeriesCollection, 'totalCount'>
    & { items: Array<Types.Maybe<(
      { __typename: 'CircleSeriesNode' }
      & { topics: (
        { __typename: 'CircleTopicConnection' }
        & Pick<Types.CircleTopicConnection, 'totalCount'>
        & { edges: Array<Types.Maybe<(
          { __typename: 'CircleTopicEdge' }
          & Pick<Types.CircleTopicEdge, 'cursor'>
          & { node: (
            { __typename: 'CircleTopicNode' }
            & Pick<Types.CircleTopicNode, 'id' | 'languageCode'>
            & CircleTopicFragment
          ) }
        )>> }
      ) }
      & CircleSeriesFragment
    )>> }
  ) }
);

export const CircleSeriesFragmentDoc = gql`
    fragment CircleSeries on CircleSeriesNode {
  name
  id
  slug
  uuid
  description
  shortDescription
  illustration
}
    `;
export const FetchSeriesDocument = gql`
    query fetchSeries {
  circleSeriesCollection {
    totalCount
    items {
      ...CircleSeries
    }
  }
}
    ${CircleSeriesFragmentDoc}`;

/**
 * __useFetchSeriesQuery__
 *
 * To run a query within a React component, call `useFetchSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSeriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchSeriesQuery(baseOptions?: Apollo.QueryHookOptions<FetchSeriesQuery, FetchSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSeriesQuery, FetchSeriesQueryVariables>(FetchSeriesDocument, options);
      }
export function useFetchSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSeriesQuery, FetchSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSeriesQuery, FetchSeriesQueryVariables>(FetchSeriesDocument, options);
        }
export type FetchSeriesQueryHookResult = ReturnType<typeof useFetchSeriesQuery>;
export type FetchSeriesLazyQueryHookResult = ReturnType<typeof useFetchSeriesLazyQuery>;
export type FetchSeriesQueryResult = Apollo.QueryResult<FetchSeriesQuery, FetchSeriesQueryVariables>;
export const FetchSeriesWithSessionsDocument = gql`
    query fetchSeriesWithSessions {
  circleSeriesCollection {
    totalCount
    items {
      ...CircleSeries
      topics {
        totalCount
        edges {
          cursor
          node {
            id
            languageCode
            ...CircleTopic
          }
        }
      }
    }
  }
}
    ${CircleSeriesFragmentDoc}
${CircleTopicFragmentDoc}`;

/**
 * __useFetchSeriesWithSessionsQuery__
 *
 * To run a query within a React component, call `useFetchSeriesWithSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSeriesWithSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSeriesWithSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchSeriesWithSessionsQuery(baseOptions?: Apollo.QueryHookOptions<FetchSeriesWithSessionsQuery, FetchSeriesWithSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSeriesWithSessionsQuery, FetchSeriesWithSessionsQueryVariables>(FetchSeriesWithSessionsDocument, options);
      }
export function useFetchSeriesWithSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSeriesWithSessionsQuery, FetchSeriesWithSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSeriesWithSessionsQuery, FetchSeriesWithSessionsQueryVariables>(FetchSeriesWithSessionsDocument, options);
        }
export type FetchSeriesWithSessionsQueryHookResult = ReturnType<typeof useFetchSeriesWithSessionsQuery>;
export type FetchSeriesWithSessionsLazyQueryHookResult = ReturnType<typeof useFetchSeriesWithSessionsLazyQuery>;
export type FetchSeriesWithSessionsQueryResult = Apollo.QueryResult<FetchSeriesWithSessionsQuery, FetchSeriesWithSessionsQueryVariables>;